<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <FreeHeader
        :lingronCounter="lingronCounter"
        :stepCounter="stepCounter"
        :maxLingron="maxLingron"
        :fromStepField="fromStepField"
      />

      <v-flex xs12 d-flex text-xs-center class="questionTitle">
        <h3>
          Nézd meg újra
          <!-- <v-btn color="info" fab small @click="tipp.show = true">
            <v-icon>info</v-icon>
          </v-btn> -->
        </h3>
      </v-flex>

      <v-flex xs12 text-xs-center>
        <!-- Main video -->
        <video
          v-if="video.filename !== null && video.filename.length > 0"
          height="300"
          controls
          preload="metadata"
          webkit-playsinline="true"
          playsinline="true"
          :poster="
            this.$store.getters.getApiUrl +
              '/assets/admin/img/new_lingron_250.png'
          "
        >
          <source
            :src="
              this.$store.getters.getApiUrl + '/uploads/video/' + video.filename
            "
            type="video/mp4"
          />
          <source
            :src="
              this.$store.getters.getApiUrl + '/uploads/video/' + video.filename
            "
            type="video/ogg"
          />
          <source
            :src="
              this.$store.getters.getApiUrl + '/uploads/video/' + video.filename
            "
            type="video/webm"
          />
          Your browser does not support the video tag.
        </video>

        <!-- Youtube video -->
        <div v-if="youtube.url !== null && youtube.url.length > 0">
          <LazyYoutubeVideo
            :src="'https://www.youtube.com/embed/' + youtube.url"
          />
        </div>
      </v-flex>

      <v-flex
        v-if="
          youtube.url === null &&
            video.filename === null &&
            file.filename !== null
        "
        xs12
        class="text-xs-center"
      >
        <img
          v-show="!voiceShow"
          :src="require('@/assets/img/voice_muted.gif')"
          alt="voice_muted"
          height="100px"
        />
        <img
          v-show="voiceShow"
          :src="require('@/assets/img/voice.gif')"
          alt="voice"
          height="100px"
        />
      </v-flex>

      <v-flex
        v-if="
          youtube.url === null &&
            video.filename === null &&
            file.filename !== null
        "
        xs12
        text-xs-center
      >
        <v-btn
          color="#FF0063"
          fab
          large
          class="text-light"
          @click.prevent="isPlaying ? pauseSound(file) : playSound(file)"
        >
          <v-icon v-if="isPlaying" large>pause</v-icon>
          <v-icon v-else large>play_arrow</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12 offset-md1 md10 text-xs-left>
        <v-layout
          row
          wrap
          v-for="(item, index) in conversationItems"
          :key="index"
        >
          <v-flex :class="renderFlex(index)" mt-1>
            <v-layout fill-height>
              <v-flex :class="renderAvatar(index)" style="position:relative;">
                <v-spacer></v-spacer>
                <v-avatar style="position:absolute; bottom: 0 !important;">
                  <img
                    v-if="item.picture !== null"
                    :src="apiUrl + '/uploads/picture/' + item.picture.filename"
                    :alt="item.name"
                  />
                </v-avatar>
              </v-flex>

              <v-flex :class="renderCardFlex(index)">
                <div :class="renderName(index)" class="text-muted">
                  {{ item.name }}
                </div>
                <v-card :class="renderCard(index)" dark>
                  <div class="conversationOther p-2">
                    {{ item.content_other }}
                  </div>
                  <v-divider></v-divider>
                  <div class="conversationMain pb-2">
                    {{ item.content_main }}
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-spacer></v-spacer>

      <v-flex xs12 text-xs-center class="">
        <v-divider></v-divider>
        <v-layout row wrap class="bgBlue">
          <v-flex xs12 @click="goToSummary">
            <v-btn large dark flat>
              Összefoglaló
              <v-icon right dark>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="tipp.show" width="600">
      <v-card>
        <v-card-title class="headline mainBlue dark text-light">
          Kérdések

          <v-spacer></v-spacer>

          <v-btn color="error" fab small @click="tipp.show = false">
            <v-icon class="text-light">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text @click="tipp.show = false">
          <p>
            Egy igazi LINGO SKILLER (csúcs-nyelvhasználó) hallás után gyakorol.
            <br />
            Nálunk minden egyes meghallgatott anyag egy lépésnek számít a cél
            felé. <br />
            Ezt jelképezi a lábnyom, amit itt látsz. <br />
            A lecke új mondataival mindig HALLÁS UTÁN, egy könnyű kirakós
            feladaton keresztül ismerkedsz meg. <br />
            Egy leckében 3-4 mondattal gyakorlunk. <br />
            A lecke további részében ezeket a mondatokat bontjuk apróbb
            részekre.
          </p>
        </v-card-text>

        <v-card-actions class="text-xs-center">
          <v-layout row wrap>
            <v-flex xs12 text-xs-center>
              <v-btn color="error" dark @click="tipp.show = false">
                Bezár
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";
import LazyYoutubeVideo from "vue-lazy-youtube-video";
import FreeHeader from "@/components/partials/FreeHeader";

export default {
  components: {
    LazyYoutubeVideo,
    FreeHeader
  },
  data: function() {
    return {
      lessonId: this.$route.params.lessonId,
      // lessonId: this.$store.getters.currentLessonId,
      apiUrl: this.$store.getters.getApiUrl,
      conversation: "",
      conversationItems: "",
      conversationCount: "",
      playedFile: "",
      playedNow: false,
      voiceShow: false,
      file: "",
      nextStep: false,
      isPlaying: false,
      progressIndicator: this.$store.getters.getProgressIndicator,
      lastQuestion: this.$store.getters.getLastQuestion,
      lastQuestionState: this.$store.getters.getLastQuestionState,
      stepCounter: this.$store.getters.getStepCounter,
      lingronCounter: this.$store.getters.getLingronCounter,
      maxLingron: this.$store.getters.getMaxLingron,
      redirectUrl: this.$store.getters.isFreeLessonRedirectUrl,
      fromStepField: this.$store.getters.getFromStepfield,
      tipp: {
        show: false
      },
      video: {
        filename: "",
        title: ""
      },
      youtube: {
        url: "",
        show: true
      }
    };
  },
  methods: {
    getConversationData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/conversation/free", {
          lessonId: this.$data.lessonId
        })
        .then(response => {
          // console.log("conversation - resp: ", response.data);

          //If load false === cant find conversation to the lesson, redirect to summary
          if (response.data.load == 1) {
            this.$data.conversation = response.data.conversation; //Load the data
            this.$data.conversationItems = response.data.conversationItems; //Load the data
            this.$data.file = response.data.file; //Load the sound file
            this.$data.conversationCount = response.data.conversationCount; //How many item in conversation

            if (response.data.video !== null) {
              this.$data.video.filename = response.data.video.filename;
              this.$data.video.title = response.data.video.title;
            }

            if (response.data.youtubeUrl !== null) {
              this.$data.youtube.url = response.data.youtubeUrl;
              this.$data.youtube.show = true;
            }
          } else {
            // console.log('Megyunk summary');
            this.goToSummary(); //Redirect to summary
          }
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log("conversation - error: ", error);
          }
        });
    },
    playSound(file) {
      if (file) {
        //Play the audio file
        let sound =
          this.$store.getters.getApiUrl + "/uploads/sound/" + file.filename;
        var audio = new Audio(sound);

        if (!this.$data.playedNow) {
          this.$data.playedNow = true;
          this.$data.voiceShow = true;
          this.$data.isPlaying = true;
          this.$data.playedFile = audio;

          audio.play();

          let v = this;

          setTimeout(function() {
            v.$data.playedNow = false;
            v.$data.voiceShow = false;

            //Increment the stepCounter
            v.$data.stepCounter++;

            //Store the new stepCounter
            v.$store.commit("updateStepCounter", {
              stepCounter: v.$data.stepCounter
            });
          }, 2700);
        } else {
          var audio = this.$data.playedFile;
          audio.play();
          this.$data.isPlaying = true;
          this.$data.playedFile = audio;

          //console.log('playSound - else - ', this.$data.playedFile);
        }
      } else {
        // console.log('No file found', sound);
      }
    },
    pauseSound(file) {
      var audio = this.$data.playedFile;
      audio.pause();
      this.$data.isPlaying = false;
    },
    stopSound() {
      if (this.$data.playedFile !== null && this.$data.isPlaying) {
        //Stop the audio file
        var audio = this.$data.playedFile;
        audio.pause();
      }

      //Move to stepfield
      this.$router.push({ name: "home" });
    },
    goToSummary() {
      //Stop the played file if it is already playing
      this.stopSound();

      this.$router.push({
        name: "freeSummary",
        params: {
          lessonId: this.$data.lessonId
        }
      });

      // location.replace(this.$data.redirectUrl);
    },
    renderFlex(index) {
      let newIndex = index;

      if (newIndex % 2 === 0) {
        return "xs12 sm8";
      } else {
        return "xs12 offset-sm4 sm8";
      }
    },
    renderCard(index) {
      if (index % 2 === 0) {
        return "pilled mainGrey messageLeft text-black";
      } else {
        return "pilled mainLightBlue messageRight";
      }
    },
    renderCardFlex(index) {
      if (index % 2 === 0) {
        return "xs10 order-xs2";
      } else {
        return "xs10 order-xs1";
      }
    },
    renderAvatar(index) {
      if (index % 2 === 0) {
        return "xs2 order-xs1 text-xs-right mr-5 pr-3";
      } else {
        return "xs2 order-xs2 ml-2";
      }
    },
    renderName(index) {
      if (index % 2 === 0) {
        return "text-xs-left";
      } else {
        return "text-xs-right";
      }
    },
    redirectToUrl() {
      location.replace(this.$data.redirectUrl);
    }
  },
  created: function() {
    this.getConversationData();
  }
};
</script>
